import {
  INVITE_ADMIN_ACTION,
  INVITE_CREATOR_ACTION,
  INVITE_CREATOR_LITE_ACTION,
  INVITE_VIEWER_ACTION,
} from './scopes';

export const ORG_ROLE_ADMIN = 'admin';
export const ORG_ROLE_VIEWER = 'viewer';
export const ORG_ROLE_CREATOR = 'creator';
export const ORG_ROLE_CREATOR_LITE = 'creator_lite';
export const ORG_ROLE_GUEST = 'guest';
export const ORG_ROLE_USER = 'user';

export const ORG_ROLE_INDEFINITE_ARTICLE_MAP = {
  [ORG_ROLE_ADMIN]: 'an',
  [ORG_ROLE_CREATOR]: 'a',
  [ORG_ROLE_CREATOR_LITE]: 'a',
  [ORG_ROLE_GUEST]: 'a',
  [ORG_ROLE_VIEWER]: 'a',
};

export const ORG_ROLE_DISPLAY_NAMES = {
  [ORG_ROLE_ADMIN]: 'Admin',
  [ORG_ROLE_CREATOR]: 'Creator',
  [ORG_ROLE_CREATOR_LITE]: 'Creator Lite',
  [ORG_ROLE_GUEST]: 'Guest',
  [ORG_ROLE_VIEWER]: 'Viewer',
};

export const ORG_ROLE_DESCRIPTIONS = {
  [ORG_ROLE_ADMIN]: 'Manages Workspace. Can record unlimited videos.',
  [ORG_ROLE_CREATOR]: 'Can record unlimited videos.',
  [ORG_ROLE_CREATOR_LITE]: 'Can record videos up to 5 min each.',
  [ORG_ROLE_GUEST]:
    'Shared SDK account. Anonymous users can record videos with limits.',
  [ORG_ROLE_VIEWER]: 'View-only access. Cannot record.',
};

export const ALL_ORG_ROLES = [
  ORG_ROLE_ADMIN,
  ORG_ROLE_VIEWER,
  ORG_ROLE_CREATOR,
  ORG_ROLE_CREATOR_LITE,
  ORG_ROLE_GUEST,
];

export const PAID_ORG_ROLES = [ORG_ROLE_ADMIN, ORG_ROLE_CREATOR];

/**
Useful for determining if a role has been upgraded or downgraded for analytics events. The higher the number
the greater permissions the role has. If a new role is added in the middle we can use decimal values:
[ORG_ROLE_CREATOR_PLUS]: 2.5
*/
export const ORG_ROLE_HIERARCHY = {
  [ORG_ROLE_ADMIN]: 4,
  [ORG_ROLE_CREATOR]: 3,
  [ORG_ROLE_CREATOR_LITE]: 2,
  [ORG_ROLE_VIEWER]: 1,
};

/**
 * Used for specific actions/messages based on if the role
 * was promoted or demoted.
 */
export const ROLE_DEMOTION = 'role-demotion';
export const ROLE_PROMOTION = 'role-promotion';

export const ORG_UPDATE_ROLE_SOURCE = {
  UNKNOWN: 'unknown',
  ADMIN_ACTION: 'admin-action',
  PLAN_DOWNGRADE: 'plan-downgrade',
  PLAN_UPGRADE: 'plan-upgrade',
  TRANSFER_ADMIN: 'transfer-admin',
  DOWNGRADE_TO_FREE: 'downgrade-to-free',
  ROLE_UPGRADE_REQUEST: 'role-upgrade-request',
};

export const ONBOARDING_INVITE_SOURCE = 'welcome-onboarding';
export const IN_APP_INVITE_SOURCE = 'team-invite-modal';
export const ADMIN_TOOL_INVITE_SOURCE = 'admin-tool';
export const VIDEO_SHARE_INVITE_SOURCE = 'video-share';
export const SLACK_CONTACT_IMPORT_INVITE_SOURCE = 'contact_import_slack';
export const GOOGLE_CONTACT_IMPORT_INVITE_SOURCE = 'contact_import_google';
export const SHARE_VIDEO_MODAL_INVITE_SOURCE = 'share_video_modal';

/**  Usage: ROLE_CHANGE_QUANTITY_DELTAS_MAP[previousRole][currentRole] */
export const ROLE_CHANGE_QUANTITY_DELTAS_MAP = {
  [ORG_ROLE_ADMIN]: {
    [ORG_ROLE_CREATOR]: {
      admins: -1,
      creators: 1,
      viewers: 0,
    },
    [ORG_ROLE_VIEWER]: {
      admins: -1,
      creators: 0,
      viewers: 1,
    },
    [ORG_ROLE_CREATOR_LITE]: {
      admins: -1,
      creators: 0,
      viewers: 1,
    },
  },
  [ORG_ROLE_CREATOR]: {
    [ORG_ROLE_ADMIN]: {
      admins: 1,
      creators: -1,
      viewers: 0,
    },
    [ORG_ROLE_VIEWER]: {
      admins: 0,
      creators: -1,
      viewers: 1,
    },
    [ORG_ROLE_CREATOR_LITE]: {
      admins: 0,
      creators: -1,
      viewers: 1,
    },
  },
  [ORG_ROLE_VIEWER]: {
    [ORG_ROLE_ADMIN]: {
      admins: 1,
      creators: 0,
      viewers: -1,
    },
    [ORG_ROLE_CREATOR]: {
      admins: 0,
      creators: 1,
      viewers: -1,
    },
    [ORG_ROLE_CREATOR_LITE]: {
      admins: 0,
      creators: 0,
      viewers: 0,
    },
  },
  [ORG_ROLE_CREATOR_LITE]: {
    [ORG_ROLE_ADMIN]: {
      admins: 1,
      creators: 0,
      viewers: -1,
    },
    [ORG_ROLE_CREATOR]: {
      admins: 0,
      creators: 1,
      viewers: -1,
    },
    [ORG_ROLE_VIEWER]: {
      admins: 0,
      creators: 0,
      viewers: 0,
    },
  },
};

export const SCOPE_FOR_ROLE = {
  [ORG_ROLE_ADMIN]: INVITE_ADMIN_ACTION,
  [ORG_ROLE_CREATOR]: INVITE_CREATOR_ACTION,
  [ORG_ROLE_CREATOR_LITE]: INVITE_CREATOR_LITE_ACTION,
  [ORG_ROLE_VIEWER]: INVITE_VIEWER_ACTION,
};
